import listingService from '../../common/services/listingsService';
import {
  FETCH_BUSINESS_LISTINGS,
  FETCH_FEATURED_LISTINGS,
  FETCH_LISTING_DETAILS,
  FETCH_ADMIN_LISTINGS,
  FETCH_ADMIN_LISTINGS_STARTED,
  EDITLISTING,
  SELECT_PLAN,
  RESETFORMS,
} from './types';

export const fetchBusinessListings = (
  query = { type: 'all' },
  pageNumber = 1,
) => dispatch => {
  listingService.getBusinessListings(query, pageNumber).then(
    res => {
      dispatch({
        type: FETCH_BUSINESS_LISTINGS,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: FETCH_BUSINESS_LISTINGS,
        payload: { data: [] },
      });
    },
  );
};

export const fetchFeaturedBusinesses = () => dispatch => {
  listingService.getFeaturedBusinesses().then(
    res => {
      dispatch({
        type: FETCH_FEATURED_LISTINGS,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: FETCH_FEATURED_LISTINGS,
        payload: { data: [] },
      });
    },
  );
};

export const fetchAdminListings = (pageNumber = 1) => dispatch => {
  dispatch({ type: FETCH_ADMIN_LISTINGS_STARTED });
  listingService.getAdminListings(pageNumber).then(
    res => {
      dispatch({
        type: FETCH_ADMIN_LISTINGS,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: FETCH_ADMIN_LISTINGS,
        payload: { data: [] },
      });
    },
  );
};

export const searchAdminListings = (
  startDate,
  endDate,
  searchQuery,
  status,
  byId,
  pageNumber = 1,
) => async dispatch => {
  dispatch({ type: FETCH_ADMIN_LISTINGS_STARTED });
  await listingService
    .searchAdminListings(
      startDate,
      endDate,
      searchQuery,
      status,
      byId,
      pageNumber,
    )
    .then(
      res => {
        dispatch({
          type: FETCH_ADMIN_LISTINGS,
          payload: res.data,
        });
      },
      err => {
        dispatch({
          type: FETCH_ADMIN_LISTINGS,
          payload: { data: [] },
        });
      },
    );
};

export const fetchListingDetails = id => dispatch => {
  listingService.getListingDetails(id).then(
    res => {
      dispatch({
        type: FETCH_LISTING_DETAILS,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: FETCH_LISTING_DETAILS,
        payload: {},
      });
    },
  );
};

export const editListing = id => dispatch => {
  listingService.getListingDetails(id, true).then(
    res => {
      dispatch({
        type: EDITLISTING,
        payload: res.data,
      });
    },
    err => {
      dispatch({
        type: EDITLISTING,
        payload: {},
      });
    },
  );
};

export const selectPlan = plan => dispatch => {
  dispatch({
    type: SELECT_PLAN,
    payload: plan,
  });
};

export const resetForm = () => dispatch => {
  dispatch({
    type: RESETFORMS,
  });
};
